/* VIG — lente de aumento en las fotos de producto (estilo Elite Max)
   Solo escritorio con mouse. No toca el clic que abre el lightbox del tema. */
(function () {
  'use strict';

  var ZOOM = 2.2;      // aumento
  var LENTE = 200;     // diametro del lente en px

  // La condicion de escritorio se evalua en CADA movimiento, no al cargar:
  // una pestania en segundo plano reporta innerWidth 0 y apagaria el zoom para siempre.
  function esEscritorio() {
    return window.innerWidth >= 990 &&
           window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  var css = ''
    + '.vig-lente{position:absolute;pointer-events:none;border-radius:50%;'
    + 'border:3px solid rgba(255,255,255,.95);box-shadow:0 2px 14px rgba(13,32,87,.28);'
    + 'background-repeat:no-repeat;background-color:#fff;opacity:0;'
    + 'transition:opacity .12s ease;z-index:5}'
    + '.vig-lente.is-on{opacity:1}'
    + '.product__media.vig-zoomable{cursor:crosshair}';
  var st = document.createElement('style');
  st.appendChild(document.createTextNode(css));
  document.head.appendChild(st);

  var lente = null;
  var actual = null;

  function crearLente() {
    if (lente) return lente;
    lente = document.createElement('div');
    lente.className = 'vig-lente';
    lente.style.width = LENTE + 'px';
    lente.style.height = LENTE + 'px';
    return lente;
  }

  // OJO: en Dawn, encima de la imagen hay un <button class="product__media-toggle">
  // que abre el lightbox y se come TODOS los eventos del mouse. Buscar
  // .product__media con closest() desde el target da null siempre. Hay que subir
  // hasta el contenedor del media y de ahi bajar a la imagen.
  function contenedor(t) {
    if (!t || !t.closest) return null;
    var host = t.closest('.product-media-container, modal-opener, .product__media-item, .product__media');
    if (!host) return null;
    if (host.classList && host.classList.contains('product__media')) return host;
    return host.querySelector('.product__media');
  }

  function altaRes(img) {
    var u = img.currentSrc || img.src || '';
    if (!u) return '';
    if (u.indexOf('//') === 0) u = window.location.protocol + u;
    try {
      var o = new URL(u);
      o.searchParams.set('width', '1800');
      return o.href;
    } catch (e) {
      return u;
    }
  }

  function apagar() {
    if (lente) lente.classList.remove('is-on');
    actual = null;
  }

  function mover(e) {
    if (!esEscritorio()) { apagar(); return; }

    var cont = contenedor(e.target);
    if (!cont) { apagar(); return; }

    var img = cont.querySelector('img');
    if (!img || !img.naturalWidth) { apagar(); return; }

    var r = img.getBoundingClientRect();
    if (!r.width || !r.height) { apagar(); return; }

    var x = e.clientX - r.left;
    var y = e.clientY - r.top;
    if (x < 0 || y < 0 || x > r.width || y > r.height) { apagar(); return; }

    var l = crearLente();
    if (actual !== img || l.parentNode !== cont) {
      actual = img;
      cont.classList.add('vig-zoomable');
      cont.appendChild(l);
      l.style.backgroundImage = 'url("' + altaRes(img) + '")';
    }

    var cr = cont.getBoundingClientRect();
    l.style.backgroundSize = (r.width * ZOOM) + 'px ' + (r.height * ZOOM) + 'px';
    l.style.backgroundPosition = (-(x * ZOOM - LENTE / 2)) + 'px ' + (-(y * ZOOM - LENTE / 2)) + 'px';
    l.style.left = (e.clientX - cr.left - LENTE / 2) + 'px';
    l.style.top = (e.clientY - cr.top - LENTE / 2) + 'px';
    l.classList.add('is-on');
  }

  document.addEventListener('mousemove', mover, { passive: true });
  document.addEventListener('mouseleave', apagar);
  window.addEventListener('scroll', apagar, { passive: true });
  window.addEventListener('resize', apagar, { passive: true });
})();
